/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Response_TimeInputs */

const en_footer_response_time = /** @type {(inputs: Footer_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We reply within two business days.`)
};

/**
* | output |
* | --- |
* | "We reply within two business days." |
*
* @param {Footer_Response_TimeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_response_time = /** @type {((inputs?: Footer_Response_TimeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Response_TimeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_response_time(inputs)
});